export default __webpack_public_path__ + "static/media/eurolight.c21dbbd3.png";